import { useDependencies } from '@servicetitan/react-ioc';

import { FeatureType } from '@fleet-pro/mobile-webview-api';

import { FeatureSetsDataStore } from '../stores/feature-sets-data.store';
import { FeatureMatchType, hasFeatures } from '../utils/has-features';

export const useFeaturesChecker = (features: FeatureType[], featureType?: FeatureMatchType) => {
    const [{ availableFeatures }] = useDependencies(FeatureSetsDataStore);

    return hasFeatures(availableFeatures, features, featureType);
};
